import { useMsal } from '@/composables/auth/useMsal';

import { loginRequest } from '@/service/auth/config';
import { getAccessToken } from '@/service/auth/utils';
import type { AxiosWrapperConfig } from '@mylight150/axios-wrapper';

export const axiosWrapperConfig: AxiosWrapperConfig = {
  apiBaseUrl: import.meta.env.VITE_APIM_BASE_URL,
  authRequired: import.meta.env.VITE_AUTH_REQUIRED === 'true',
  ocpSubscriptionKey: import.meta.env.VITE_OCP_SUBSCRIPTION_KEY,
  ocpSubscriptionKeyHeaderName: import.meta.env.VITE_OCP_SUBSCRIPTION_KEY_HEADER_NAME,
  getAccessToken: async () => {
    try {
      return await getAccessToken(loginRequest);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  onError: errorType => {
    if (errorType === 'UNAUTHORIZED') {
      const { instance } = useMsal();
      instance.value.logoutRedirect();
    }
  },
};
